export default "__VITE_ASSET__d83e0b76__"